import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'obc-botao-fechar',
  templateUrl: './botao-fechar.component.html',
  styleUrls: ['./botao-fechar.component.scss'],
})
export class BotaoFecharComponent implements OnInit {
  @Output() btnFechar = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  fechar() {
    this.btnFechar.emit();
  }
}
